export const extensionRoutes = [  {
    path: 'extensions/advanced-search',
    loadChildren: () => import('./extensions/advanced-search-plugin/advanced-search-ui-lazy.module').then(m => m.AdvancedSearchUiLazyModule),
  },
  {
    path: 'extensions/companies',
    loadChildren: () => import('./extensions/org-hierarchy-ui/routes'),
  },
  {
    path: 'catalog/products/:id/manage-variants',
    loadChildren: () => import('./extensions/admin-ui-extensions/manage-variants.routes'),
  },
  {
    path: 'catalog/products/create',
    loadChildren: () => import('./extensions/admin-ui-extensions/product-create.routes'),
  },
  {
    path: 'extensions/currency-conversion',
    loadChildren: () => import('./extensions/price-calculation/currency-conversion-routes'),
  },
  {
    path: 'extensions/redirects',
    loadChildren: () => import('./extensions/redirects-ui-extension/redirects-plugin-routes'),
  }];
